import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ApiService, DatastoreService } from 'src/app/services';
import { CommonFunctionsService } from 'src/app/services/common-functions.service';
import * as moment from 'moment';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class FormBuilderService {

  constructor(
    public dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private formBuilder: FormBuilder
  ) { }

  questions: any = {};
  forms: any = {};
  schema: any = {};

  async buildForm(formId: string, formValues: any[], childIndex: Number): Promise<FormGroup<any>> {
    const schema: any = await this.apiService.getFormSchema(formId) as any;
    console.log(schema);
    // remove haf id
    let foundKey = -1;
    for (const [idx, field] of schema.schema.fields.entries()) {
      // console.log(idx, field);
      if (field.field === 'haf_id') {
        foundKey = idx;
        break;
      }
    }
    if (foundKey > -1) {
      schema.schema.fields.splice(foundKey, 1);
    }
    const formGroup: FormGroup = new FormGroup({});
    this.schema[formId] = schema;
    if (schema.schema) {

      this.questions[formId] = schema.schema.fields;

      for (const field of schema.schema.fields) {
        const validators = (field.required) ? Validators.required : undefined;
        const foundField = formValues.find((f) => f.field === field.field);
        let f: any = false;
        if (foundField) {
          if (field.type !== 'radio') {
            f = new FormControl(foundField.value, validators);
          }
          else {
            f = new FormControl(foundField.value.toString(), validators);
          }
        }
        else {
          if (field.type !== 'upload') {
            f = new FormControl('', validators);
          }
          else {
            f = this.formBuilder.array([]);
          }

        }
        formGroup.addControl(field.field, f);

        if (field.type == 'date') {
          const dateY = new FormControl('', validators);
          const dateM = new FormControl('', validators);
          const dateD = new FormControl('', validators);
          formGroup.addControl(field.field + 'y', dateY);
          formGroup.addControl(field.field + 'm', dateM);
          formGroup.addControl(field.field + 'd', dateD);
        }
      }
    }
    console.log(`${formId}_${childIndex}`, formGroup)
    this.forms[`${formId}_${childIndex}`] = formGroup;
    return formGroup;
  }

  createItem(data: any): FormGroup {
    return this.formBuilder.group(data);
  }


  getFields(formId: string) {
    try {
      return this.questions[formId];
    }
    catch (err) {
      return [];
    }
  }

  getDetailsTitle(formId: string) {
    if (this.schema.hasOwnProperty(formId)) {
      if (this.schema[formId].schema.hasOwnProperty('form_name')) {
        return this.schema[formId].schema.form_name;
      }
    }
    return 'Test form';
  }

  getParentField(formId: string, field: any) {
    if (field.field) {
      if (field.type == 'checkbox') {
        if (field.checkbox_field) {
          const found = this.questions[formId].find((f: any) => f.field == field.checkbox_field);
          if (found) {
            return found;
          }
        }
      }
    }
    return {};
  }

  getTriggerField(formId: string, field: any) {
    if (field.field) {
      // if (field.type == 'checkbox') {
      //   if (field.checkbox_field) {
      //     const found = this.questions[formId].find((f: any) => f.field == field.trigger);
      //     if (found) {
      //       return found;
      //     }
      //   }
      // }
      // else {
        const found = this.questions[formId].find((f: any) => f.field == field.trigger);
        if (found) {
          return found;
        }
      }
    // }
    return {};
  }

  shouldShowConditional(formId: string, field: any, idx: Number): boolean {
    if (field.conditional) {
      const parent = this.getTriggerField(formId, field);
      const parentForm = this.forms[`${formId}_${idx}`];
      if (parentForm.get(parent.field) === null || parentForm.controls[field.field] === undefined) {
        return false
      } else {
        // despite being called trigger_value, trigger_value can be an array of trigger values
        let trigger_values = field.trigger_value
        if (!(trigger_values instanceof Array)) {
          trigger_values = [trigger_values]
        }
        let triggerValue;
        for (let trigger_value of trigger_values) {
          if (parent.type == 'checkbox') {
            triggerValue = trigger_value;
          } else {
            triggerValue = `${trigger_value}`;
          }
          if (parentForm.get(parent.field).value === triggerValue) {
            if (parentForm.controls[field.field].status === "DISABLED") {
              parentForm.controls[field.field].enable();
            }
            return true;
          }
        }

        if (parentForm.controls[field.field].status !== "DISABLED") {
          if(field.type !== "upload"){
            parentForm.controls[field.field].setValue("")
          } else{
            parentForm.controls[field.field].setValue([])
          }
          parentForm.controls[field.field].disable();
        }
        return false;
      }
    }
    else {
      return true;
    }

  }

}
